import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';

const getStartDate = (date, isOnlyDate) => {
  return isOnlyDate
    ? moment.parseZone(date).format(DateFormats.MonthDayYear)
    : moment(date).format(DateFormats.MonthDayYearTime);
};

export const formatTasksResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    phoneNumbers: {
      phone: item?.phone,
      phones: item?.phones
    },
    taskType: item?.customTask ? `${item.taskType} - ${item.customTask}` : item?.taskType,
    taskStatus: {
      id: item?.taskStatusId,
      name: item?.taskStatus
    },
    company: {
      id: item?.companyId ?? null,
      name: item?.company ?? null
    },
    contact: {
      entityType: item?.entityType ?? null,
      entityTypeId: item?.entityTypeId ?? null,
      fullName: item?.contactName ?? null,
      id: item?.contactId ?? item?.entityId ?? null
    },
    startDate: item?.startDatetime
      ? getStartDate(item?.startDatetime, item?.startDatetimeIsOnlyDate)
      : null,
    communication_actions: {
      email: item?.email,
      phone: item?.phone
    },
    outcome: item?.customOutcome ? `${item?.outcome} - ${item.customOutcome}` : item?.outcome
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
